package kz.dentalcrm.app.data.network.response_model

import kotlinx.serialization.Serializable


@Serializable
data class Pivot(
    val actual_price: Int,
    val amount: Int,
    val appointment_id: Int,
    val discount: Int,
    val service_id: Int
)